<template>
	<component
		:is="tag"
		:href="href"
		:type="tag=='a' ? null : type"
		:class="['eb-button', size, state, hierarchy, withIcon, centered, expanded, siteColor]"
		@click="onClick"
	>
		<slot />
	</component>
</template>

<script>
/**
 * Les boutons sont principalement utilisés pour effectuer des actions telles que, enregistrer, supprimer, quitter, etc. 
 * Ils se présentent sous différentes formes, styles, tailles...

 */
export default {
	name: "EbButton",
	status: "prototype",
	release: "1.0.0",
	props: {
		/**
		 * Les balises html utilisées pour les liens.
		 * @values button, a
		 */
		tag: {
			type: String,
			default: "button",
			validator: (value) => {
				return value.match(/(button|a)/);
			},
		},
		/**
		 * Taille du bouton. Medium par défaut.
		 * @values small, medium, large
		 */
		size: {
			type: String,
			default: "medium",
			validator: (value) => {
				return value.match(/(small|medium|large)/);
			},
		},
		/**
		 * Lorsque le bouton est un lien, utiliser cette option pour donner un href.
		 */
		href: {
			type: String,
			default: null,
		},
		/**
		 * Type du bouton
		 * @values button, submit, reset
		 */
		type: {
			type: String,
			default: 'button',
			validator: (value) => {
				return value.match(/(button|submit|reset)/);
			},
		},
		/**
		 * Différents états d'un bouton.
		 * @values hover, active, focus, disabled
		 */
		state: {
			type: String,
			default: null,
			validator: (value) => {
				return value.match(/(null|hover|active|focus|disabled)/);
			},
		},
		/**
		 * Donne le style approprié en fonction de la hiérarchie des informations
		 * @values primaire, secondaire, texte, destructif, CTA
		 */
		hierarchy: {
			type: String,
			default: "primary",
			validator: (value) => {
				return value.match(/(primary|secondary|text|destructive|cta)/);
			},
		},
		/**
		 * Bouton avec picto.
		 * @values primaire, secondaire, texte, destructif, CTA
		 */
		withIcon: {
			type: String,
			default: null,
			validator: (value) => {
				return value.match(/(null|icon-before|icon-after|icon-only)/);
			},
		},
		/**
		 * Bouton centré.
		 * @values 
		 */
		centered: {
			type: String,
			default: null,
			validator: (value) => {
				return value.match(/(null|centered)/);
			},
		},
		/**
		 * Bouton pleine largeur.
		 * @values 
		 */
		expanded: {
			type: String,
			default: null,
			validator: (value) => {
				return value.match(/(null|expanded)/);
			},
		},
		/**
		 * Bouton de la couleur du site
		 * @values 
		 */
		siteColor: {
			type: String,
			default: null,
			validator: (value) => {
				return value.match(/(null|site-color)/);
			},
		},
	},
	methods: {
		onClick: function(event) {
			this.$emit('click',event)
		}
	}
};
</script>
